// extracted by mini-css-extract-plugin
export default {"innerWrapper":"vB-z","tooltipWrapper":"wB-z","icon":"xB-z","tooltip":"yB-z","content":"zB-z"};